import React from 'react'
import {documentationYear, documentationCategories} from "@/types/DocumentationCategory"


interface DocumentCategoryNavigationProps {
    selectedCategory: string | null;
    selectedYear: number | null;
    onSelectCategory: (category: string) => void;
}

const DocumentCategoryNavigation: React.FC<DocumentCategoryNavigationProps> = ({ selectedCategory, selectedYear, onSelectCategory}) => {
    const yearData = documentationCategories.find(item => item.year === selectedYear);
    const yearCategories = yearData?.category || [];
    
    if (selectedYear === null) selectedYear = documentationYear[0];

    return (
      <div className="mb-5 -mt-5 text-center">

        {/* choose category */}
        <ul className="flex flex-wrap justify-center  gap-2 mt-10">
          {yearCategories.map((category) => (
            <li 
              key={category}
              className={` border hover:border-defaultBlue rounded-full  p-1 px-5 font-semibold hover:text-defaultBlue transition-colors cursor-pointer ${
                (selectedCategory == category)
                  ? 'text-defaultBlue border-defaultBlue'
                  : 'text-gray-400 border-gray-400'
              }`}
              onClick={() => onSelectCategory(category)}
            >
              {category}
            </li>
          ))}
        </ul>
      </div>
    );
  };
  
  

export default DocumentCategoryNavigation